<div class="container">
  <div class="row">
    <div class="col-lg-4 col-md-4 col-sm-4">
      <img src="{{brandData?.mailLogo}}" /><br /><br />
      <!-- <p>463 Kilkare Rd<br />Sunol CA 94586<br /></p> -->
    </div>
    <div class="col-lg-2 col-md-2 col-sm-2">
      <div class="footer">
        <ul *ngIf="!loggedIn">
          <!-- <li>
            <a
              routerLink="/products"
              routerLinkActive="myactive"
              rel="noreferrer"
              >Products</a
            >
          </li> -->
          <li>
            <a
              routerLink="/about"
              routerLinkActive="myactive"
              [routerLinkActiveOptions]="{ exact: true }"
              >Home</a
            >
          </li>
          <li><a routerLink="/team" routerLinkActive="myactive">Team</a></li>
          <li>
            <a routerLink="/wellness" routerLinkActive="myactive">Wellness</a>
          </li>
        </ul>
        <ul *ngIf="loggedIn && ayurAdmin_role != 'AyurwayAdmin'">
          <!-- <li>
            <a routerLink="/products" routerLinkActive="myactive">Products</a>
          </li> -->
          <li>
            <a
              routerLink="/about"
              routerLinkActive="myactive"
              [routerLinkActiveOptions]="{ exact: true }"
              >Home</a
            >
          </li>
          <li><a routerLink="/team" routerLinkActive="myactive">Team</a></li>
          <!-- <li><a routerLink="/wellness"  routerLinkActive="myactive" >Wellness</a></li> -->
          <li>
            <a
              href="{{ ahyushUrl }}"
              target="_blank"
              routerLinkActive="myactive"
              >Wellness</a
            >
          </li>
        </ul>

        <ul *ngIf="loggedIn && ayurAdmin_role == 'AyurwayAdmin'">
          <!-- <li><a routerLink="/admin/home" routerLinkActive="myactive" [routerLinkActiveOptions]="{exact:true}">Home</a></li> -->
          <li>
            <a
              routerLink="/admin/all-appointmentlist"
              routerLinkActive="myactive"
              [routerLinkActiveOptions]="{ exact: true }"
              >All Appointments</a
            >
          </li>
          <li>
            <a routerLink="/admin/doctorlist" routerLinkActive="myactive"
              >Doctor</a
            >
          </li>
          <li>
            <a routerLink="/admin/memberlist" routerLinkActive="myactive"
              >Member</a
            >
          </li>
          <li>
            <a routerLink="/admin/home" routerLinkActive="myactive">Inbox</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="col-lg-2 col-md-2 col-sm-2">
      <div class="footer">
        <ul *ngIf="!loggedIn">
          <!-- <li>
            <a routerLink="/service" routerLinkActive="myactive">Services</a>
          </li> -->
          <li>
            <a routerLink="/talktodoctor" routerLinkActive="myactive"
              >Talk to Doctor</a
            >
          </li>
          <li>
            <a routerLink="/providercorner" routerLinkActive="myactive"
              >Provider Corner</a
            >
          </li>
          <li>
            <a routerLink="/contactus" routerLinkActive="myactive"
              >Contact Us</a
            >
          </li>
        </ul>
        <ul *ngIf="loggedIn && ayurAdmin_role != 'AyurwayAdmin'">
          <!-- <li>
            <a routerLink="/service" routerLinkActive="myactive">Services</a>
          </li> -->
          <li class="dropdown" *ngIf="member_role == 'member'">
            <a routerLink="/talktodoctor">Talk to Doctor </a>
          </li>
          <li *ngIf="doctor_role == 'doctor'">
            <a routerLink="/providercorner" routerLinkActive="myactive"
              >Provider Corner</a
            >
          </li>
          <li>
            <a routerLink="/contactus" routerLinkActive="myactive"
              >Contact Us</a
            >
          </li>
        </ul>

        <ul *ngIf="userdetails && ayurAdmin_role == 'AyurwayAdmin'">
          <!-- <li><a routerLink="/admin/home" routerLinkActive="myactive" [routerLinkActiveOptions]="{exact:true}">Home</a></li> -->
          <li>
            <a
              routerLink="/admin/all-appointmentlist"
              routerLinkActive="myactive"
              [routerLinkActiveOptions]="{ exact: true }"
              >All Appointments</a
            >
          </li>
          <li>
            <a routerLink="/admin/doctorlist" routerLinkActive="myactive"
              >Doctor</a
            >
          </li>
          <li>
            <a routerLink="/admin/memberlist" routerLinkActive="myactive"
              >Member</a
            >
          </li>
          <li>
            <a routerLink="/admin/home" routerLinkActive="myactive">Inbox</a>
          </li>
        </ul>
      </div>
    </div>

    <div class="col-lg-4 col-md-4 col-sm-4">
      <div class="social">
        <ul>
          <!-- <li>Follows Us</li> -->
          <!-- <li>
            <a href={{socialUrl?.twitter}} target="_blank"
              ><i class="fa fa-twitter"></i
            ></a>
          </li> -->
          <li>
            <a href={{socialUrl?.facebook}} target="_blank"
              ><i class="fa fa-facebook"></i
            ></a>
          </li>
          <!-- <li>
            <a
              href={{socialUrl?.insta}}
              target="_blank"
              ><i class="fa fa-instagram"></i
            ></a>
          </li> -->
        </ul>
      </div>
    </div>

    <div class="row">
      <!-- 'cr' class is removed as of now some design related issue -->
      <div class="col-lg-9 col-md-9 col-sm-9">
        <p>&#169; {{ currentYear }} {{brandData?.brandName}}</p>
      </div>

      <div class="col-lg-3 col-md-3 col-sm-3">
        <p>
          <a class="term" routerLink="/privacy-policy" target="_blank"
            >Privacy Policy</a
          >
          |<a class="term" routerLink="/terms-and-conditions" target="_blank">
            Terms and Conditions</a
          >
        </p>
      </div>
    </div>
  </div>
</div>
